import { Box, CircularProgress, MultiSelectField, TextField } from '@medely/ui-kit';
import { Market } from '@mp/hooks';
import React, { useEffect } from 'react';
import { useWatch } from '@medely/ui-kit/react-hook-form';

type MarketsFormFieldsProps = {
  markets: Market[];
  onZipCodeChange: (value: string) => void;
  isLoading?: boolean;
};

export const MarketsFormFields = ({
  markets,
  onZipCodeChange,
  isLoading,
}: MarketsFormFieldsProps) => {
  const raw = useWatch({ name: 'zipCode' });
  const digits = String(raw ?? '').replace(/\D/g, '');

  useEffect(() => {
    if (digits.length === 5) {
      onZipCodeChange(digits);
    }
  }, [digits, onZipCodeChange]);

  const isMarketZipCodePresent = (
    market: Pick<Market, 'market_locations'>,
  ): boolean | undefined => {
    return market.market_locations
      ?.flat()
      ?.map((ml) => ml.zip_code)
      ?.includes(digits);
  };

  const marketOptions = markets.map((market) => ({
    value: market.id as number,
    label: market.display_name as string,
    disabled: isMarketZipCodePresent(market),
  }));

  return (
    <>
      <Box testId="markets-zip">
        <TextField
          name="zipCode"
          label="Zip code"
          testId="markets-zip"
          type="tel"
          maxLength={5}
          formatOnChange={(value: string) => value.replace(/\D/g, '').slice(0, 5)}
        />
      </Box>
      <Box pt={2}>
        {isLoading ? (
          <Box py={2} width="fit-content" m="auto">
            <CircularProgress testId="markets-loader" />
          </Box>
        ) : (
          <MultiSelectField
            options={marketOptions}
            name="market_ids"
            variant="list"
            label=""
            testId="markets-market-box"
          />
        )}
      </Box>
    </>
  );
};
